import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTorprojectComponent } from './simple-icons-torproject.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTorprojectComponent ],
    exports:      [ SimpleIconsTorprojectComponent ],
    bootstrap:    []
})
export class SimpleIconsTorprojectModule {}
